<template>
    <div>
        <el-divider class="title" content-position="left">基础信息</el-divider>
        <el-row :gutter="20">
            <el-col :span="12">客户姓名：{{baseinfo.customName}}</el-col>
            <el-col :span="12">预定日期：{{baseinfo.orderDate}}</el-col>
            <el-col :span="12">手机号码：{{baseinfo.phone?((baseinfo.createUserCode!=$root.getStorage('info').userId)&&$root.getStorage('menuAuth').isSeeOther=='0'?(baseinfo.phone.substring(0,3)+'****'+baseinfo.phone.substring(7)):baseinfo.phone):'无'}}</el-col>
            <el-col :span="12"><span class="ls-28">时</span>间：{{baseinfo.activityBeginTime}}~{{baseinfo.activityEndTime}}
            </el-col>
            <el-col :span="12">下单日期：{{baseinfo.createTime||''}}</el-col>
            <el-col :span="12">预定场地：{{baseinfo.houseName}}</el-col>
            <el-col :span="12"><div class="w-200" style="height: 10px"></div></el-col>
            <el-col :span="12">宴会类型：{{baseinfo.orderTypeText}}</el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
            <el-col :span="9" class="flex-n fac" v-show="baseinfo.mainPayTypeText">收费方式：{{baseinfo.mainPayTypeText}}
                {{baseinfo.paytypeContent}}
            </el-col>
            <el-col :span="15"  v-show="baseinfo.payTypes&&baseinfo.payTypes.length>0">预定费用：
                <template v-for="item,index in baseinfo.payTypes">
                    <template v-if="item.payTypeCode=='03'">
                        <el-tag size="mini">{{item.payTypeText}}</el-tag>
                        {{item.housePrice||0}}元
                    </template>
                    <template v-if="item.payTypeCode=='01'">
                        <el-tag size="mini" type="warning">{{item.payTypeText}}</el-tag>
                        {{item.onePrice||0}}元*{{item.orderCount||0}}人
                    </template>
                    <template v-if="item.payTypeCode=='02'">
                        <el-tag size="mini" type="success">{{item.payTypeText}}</el-tag>
                        {{item.onePrice||0}}元*{{item.orderCount||0}}桌
                    </template>
                </template>
            </el-col>
            <el-col v-if="baseinfo.packageName">套餐名称：{{baseinfo.packageName}}</el-col>
            <el-col v-if="baseinfo.packageContent&&baseinfo.packageContent.length>0">
                <span v-html="'('+baseinfo.packageContent+')'"></span>
                <!--（{{baseinfo.packageContent}}）-->
            </el-col>
            <el-col v-if="baseinfo.extraRealMoney">增加项目：{{baseinfo.extraRealMoney}}元</el-col>
            <el-col v-if="baseinfo.orderExtraContent&&baseinfo.orderExtraContent.length>0">（{{baseinfo.orderExtraContent}}）</el-col>
        </el-row>
        <el-divider v-if="baseinfo.mainPayTypeText||(baseinfo.payTypes&&baseinfo.payTypes.length>0)||baseinfo.packageName||(baseinfo.packageContent&&baseinfo.packageContent.length>0)||baseinfo.extraRealMoney||(baseinfo.orderExtraContent&&baseinfo.orderExtraContent.length>0)"></el-divider>
        <el-row>
            <el-col>定金金额：{{baseinfo.downPayment}}元</el-col>
            <el-col>预计应收：{{baseinfo.orderMoney||0}}元</el-col>
            <el-col>已收金额：{{baseinfo.realPayment||0}}元</el-col>
            <el-col>接待人员：{{baseinfo.createUserName||'无'}}</el-col>
            <el-col>接待电话：{{baseinfo.createUserPhone||'无'}}</el-col>
            <el-col><span class="ls-28 ">备</span>注：{{baseinfo.remark||'无'}}</el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "orderbase",
        props:{
            showcustomFrom:Boolean,
            info:Object,
        },
        data(){
            return{
                baseinfo:{}
            }
        },
        watch:{
            info(newval,oldval){
                if(newval!=oldval){
                    var info=this.info;
                    var packageContent='',orderExtraContent='',paytypeContent='';
                    for(var i in info.orderPackage.itemsExs){
                        packageContent +=(info.orderPackage.itemsExs[i].isChange=='1'?('<span style="color: #cf9236!important;" >'+info.orderPackage.itemsExs[i].itemName+'</span>'):info.orderPackage.itemsExs[i].itemName)+'、';
                    }
                    for(var i in info.orderPackage.itemsFoods){
                        packageContent +=(info.orderPackage.itemsFoods[i].isChange=='1'?('<span style="color: #cf9236!important;" >'+info.orderPackage.itemsFoods[i].foodName+'</span>'):info.orderPackage.itemsFoods[i].foodName)+'、';
                    }
                    if(packageContent.substring(packageContent.length-1,packageContent.length)=='、'){
                        info.packageContent=packageContent.substring(0,packageContent.length-1)
                    }

                    for(var i in info.orderExtra.itemsExs){
                        orderExtraContent +=info.orderExtra.itemsExs[i].itemName+':'+info.orderExtra.itemsExs[i].itemPrice+'*'+info.orderExtra.itemsExs[i].itemCount+'、';
                    }
                    for(var i in info.orderExtra.itemsFoods){
                        orderExtraContent +=info.orderExtra.itemsFoods[i].foodName+':'+info.orderExtra.itemsFoods[i].foodPrice+'*'+info.orderExtra.itemsFoods[i].foodCount+'、';
                    }
                    if(orderExtraContent.substring(orderExtraContent.length-1,orderExtraContent.length)=='、'){
                        info.orderExtraContent=orderExtraContent.substring(0,orderExtraContent.length-1)
                    }
                    for(var i in info.payTypes){
                        if(info.payTypes[i].payTypeCode=='01'){
                            paytypeContent +=(info.payTypes[i].orderCount||0) +'人、';
                        }
                        if(info.payTypes[i].payTypeCode=='02'){
                            paytypeContent +=(info.payTypes[i].orderCount||0) +'桌、';
                        }
                    }
                    if(paytypeContent.substring(paytypeContent.length-1,paytypeContent.length)=='、'){
                        paytypeContent=paytypeContent.substring(0,paytypeContent.length-1)
                    }

                    if(paytypeContent.length>0){
                        info.paytypeContent='('+ paytypeContent +')'
                    }
                    this.baseinfo=info;
                }
            }
        },
        mounted(){
            this.baseinfo=this.info;
        }
    }
</script>

<style scoped lang="scss">
    .el-divider__text {
        font-weight: 700 !important;
        color: #5295e7;
    }

</style>